// Removing internal links (SEO directive)
function navLinkFn(e) {
  e.preventDefault();
  window.location.href = this.getAttribute('data-url');
  console.log(this.getAttribute('data-url'));
}

document.addEventListener('DOMContentLoaded', function() {
  var navLinks = document.getElementsByTagName('data-link'); // Fetch all data-link tags
  for (var i = 0; i < navLinks.length; i++) {
    if (navLinks[i].hasAttribute('data-url')) { // Check if they have a 'data-url' attribute
      navLinks[i].addEventListener('click', navLinkFn); 
    }
  }
});

// Filter dropdown
// function setupEventListeners() {
//   $("#facets-dropdown-container").off('click').on('click', function(e) {
//     e.preventDefault();

//     // Toggle open class for filter-dropdown-icon
//     $(".filter-dropdown-icon").toggleClass("open");

//     // Toggle the dropdown open/close state for facets-dropdown
//     const form = $("#facets-dropdown");
//     if (form.hasClass("is-open")) {
//       form.removeClass("is-open");
//     } else {
//       form.addClass("is-open");
//     }
//   });
//  }

 function setupEventListeners() {
  const dropdownContainer = document.getElementById('facets-dropdown-container');
  const dropdownIcon = document.querySelector('.filter-dropdown-icon');
  const facetsDropdown = document.getElementById('facets-dropdown');

  if(dropdownContainer){
    dropdownContainer.addEventListener('click', function(e) {
      e.preventDefault();

      // Toggle open class for filter-dropdown-icon
      if (dropdownIcon) {
        dropdownIcon.classList.toggle('open');
      }

      // Toggle the dropdown open/close state for facets-dropdown
      if (facetsDropdown) {
        facetsDropdown.classList.toggle('is-open');
      }
    });
  }

}

 

document.addEventListener("DOMContentLoaded", function () {

  //collection filters
  setupEventListeners();  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      setupEventListeners();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  //collection/search product grid image slider
  if(window.themeVariables.settings.showGallerySlider == true){
    initGridSliders();
    initDeferredImageCards();
  }
});

if(window.themeVariables.settings.showGallerySlider == true){

  window.initGridSliders = function (scope = document) {

    const sliders = scope.querySelectorAll('.ezr-images-main');

    sliders.forEach(function (el) {

      const $el = $(el);
      const $slider = $el.find('.ezr-image-slider');
      const $prev = $el.find('.ezr-prev');
      const $next = $el.find('.ezr-next');

      if (!$slider.length || $slider.hasClass('slick-initialized')) return;

      $slider.slick({
        slidesToShow: 1,
        arrows: true,
        prevArrow: $prev,
        nextArrow: $next,
        adaptiveHeight: true
      });

    });
  };

  window.initDeferredImageCards = function (scope = document) {
    scope.querySelectorAll('.collection .product-card, .main-search .product-card')
      .forEach(card => {

        if (card.dataset.deferredInit) return;
        card.dataset.deferredInit = "true";

        let imagesLoaded = false;

        const loadOnInteraction = () => {
          if (imagesLoaded) return;
          imagesLoaded = true;
          loadDefferedImages(card);
        };

        card.addEventListener('mouseenter', loadOnInteraction, { once: true });
        card.addEventListener('touchstart', loadOnInteraction, { once: true });
        card.addEventListener('click', loadOnInteraction, { once: true });

        const slider = card.querySelector('.ezr-image-slider');
        if (slider) {
          $(slider).one('swipe', loadOnInteraction);
        }
      });
  }


  function loadDefferedImages(container) {
    const images = container.querySelectorAll('img.deffered-image[data-src]');

    images.forEach(img => {
      img.src = img.dataset.src;
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.classList.remove('deffered-image');
    });
  }

}



(function () {
  const SHOP_PAY_FLAG = 'used_shop_pay_checkout';

  // Detect Shop Pay click
  document.addEventListener('click', function (e) {
    const shopPayButton = e.target.closest('shop-pay-wallet-button');
    if (!shopPayButton) return;
    
    sessionStorage.setItem(SHOP_PAY_FLAG, 'true');
  });

  // Intercept native checkout after Shop Pay
  document.addEventListener('click', function (e) {
    const checkoutButton = e.target.closest('button[name="checkout"], [href="/checkout"]');
    if (!checkoutButton) return;

    if (sessionStorage.getItem(SHOP_PAY_FLAG) === 'true') {
      e.preventDefault();

      // Force hard checkout navigation
      window.location.href = '/checkout';
    }
  });
  
  
  new MutationObserver(()=>document.querySelectorAll('.product-card .smartwishlist').forEach(e=>e.tabIndex=-1)).observe(document.body,{childList:1,subtree:1});
})();
